/**
 * Type of action which sets the current state of noise suppression.
 *
 * {
 *     type: SET_FACE_RECOGNITION_ENABLED,
 *     enabled: boolean
 * }.
 */
export const SET_FACE_RECOGNITION_ENABLED = 'SET_FACE_RECOGNITION_ENABLED';
export const SET_FACE_MESH_ENABLED = 'SET_FACE_MESH_ENABLED';
export const FACE_RECOGNITION_OFF = 'FACE_RECOGNITION_OFF';
export const FACE_RECOGNITION_ON = 'FACE_RECOGNITION_ON';
export const GET_FACE_RECOGNITION_API_STATE = 'GET_FACE_RECOGNITION_API_STATE';
